const SCROLLING_ATTR = "data-scrolling";
const HIDE_MS = 800;

const hideTimers = new WeakMap<Element, ReturnType<typeof setTimeout>>();

function markScrolling(target: EventTarget | null) {
  if (!(target instanceof Element)) return;
  target.setAttribute(SCROLLING_ATTR, "");
  const previous = hideTimers.get(target);
  if (previous) clearTimeout(previous);
  hideTimers.set(
    target,
    setTimeout(() => {
      target.removeAttribute(SCROLLING_ATTR);
      hideTimers.delete(target);
    }, HIDE_MS),
  );
}

/** Show a pane's scrollbar while it is actively scrolling; CSS clears after idle. */
export function initAutoHideScrollbars() {
  document.addEventListener("scroll", (event) => markScrolling(event.target), {
    capture: true,
    passive: true,
  });
}
